import { useEffect, useState } from "react";
import { Gift, X } from "lucide-react";
import { WHATSAPP_URL } from "../data/site";

// Show once per session on first visit
export default function WelcomePopup() {
    const [show, setShow] = useState(false);

    useEffect(() => {
        try {
            if (sessionStorage.getItem("welcomeSeen")) return;
        } catch (e) {
            /* ignore */
        }
        // If splash intro is still running (first visit), wait until after it.
        let delay = 2400;
        try {
            if (!sessionStorage.getItem("splashSeen")) delay = 4600;
        } catch (e) {}
        const t = setTimeout(() => setShow(true), delay);
        return () => clearTimeout(t);
    }, []);

    const close = () => {
        setShow(false);
        try {
            sessionStorage.setItem("welcomeSeen", "1");
        } catch (e) {
            /* ignore */
        }
    };

    if (!show) return null;

    return (
        <div
            className="fixed inset-0 z-[80] flex items-center justify-center p-4 bg-[#0a0a0c]/85 backdrop-blur-md"
            data-testid="welcome-popup"
            onClick={close}
        >
            <div
                className="relative dashed-gold rounded-3xl p-8 md:p-10 max-w-md w-full text-center"
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    onClick={close}
                    aria-label="Kapat"
                    className="absolute top-3 right-3 w-9 h-9 rounded-full flex items-center justify-center text-[#b8b1a1] hover:text-[#f5d685] transition"
                >
                    <X className="w-4 h-4" />
                </button>

                <div className="w-14 h-14 mx-auto rounded-full bg-gradient-to-br from-[#f5d685] to-[#8a6a28] flex items-center justify-center mb-5 shadow-lg shadow-[#c9a24b]/30 animate-gold-pulse">
                    <Gift className="w-6 h-6 text-[#0a0a0c]" />
                </div>

                <div className="text-[10.5px] uppercase tracking-[0.28em] text-[#7d766a]">
                    Hoşgeldin Hediyesi
                </div>
                <h3 className="mt-2 text-2xl font-bold text-[#f4efe4]">
                    İlk randevunuza özel
                </h3>
                <div className="mt-4 font-bold text-[#f4efe4]">
                    <span className="text-5xl gold-text tracking-tight">%15</span>
                    <span className="ml-2 text-xl">İNDİRİM</span>
                </div>
                <p className="mt-4 text-[13px] text-[#b8b1a1]">
                    Tüm masaj hizmetlerimizde geçerli hoşgeldin indirimi
                </p>

                <div className="mt-6 py-3 border-y border-dashed border-[#c9a24b]/30">
                    <div className="text-[10px] uppercase tracking-[0.24em] text-[#7d766a] mb-1.5">
                        Kupon Kodu
                    </div>
                    <div className="text-lg font-bold tracking-[0.35em] gold-text">
                        CEGU15
                    </div>
                </div>

                <a
                    href={WHATSAPP_URL}
                    target="_blank"
                    rel="noreferrer"
                    onClick={close}
                    className="btn btn-gold w-full mt-6"
                    data-testid="welcome-cta"
                >
                    WhatsApp'tan Randevu Al
                </a>
                <div className="mt-3 text-[11px] text-[#7d766a]">
                    * Randevu sırasında kuponu belirtiniz
                </div>
            </div>
        </div>
    );
}
